import { Injectable, Inject, Output, EventEmitter } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { SearchGlobalModalComponent } from './modals/search-global-modal/search-global-modal.component';
import { AppState } from '../store/app.state';
import { OrganizationSelectors } from '@states/organization/organization.selector-types';

@Injectable({
  providedIn: 'root',
})
export class GlobalKeyboardService {
  @Output() searchDialogOpened = new EventEmitter<boolean>(); // Event to notify when dialog is opened or closed
  private isDialogOpen = false;
  private isInitialized = false;
  private isGlobalSearchEnabled = true;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private dialog: MatDialog,
    private store$: Store<AppState>,
  ) { }

  init(): void {
    if (this.isInitialized) {
      return;
    }

    this.isInitialized = true;
    this.store$.select(OrganizationSelectors.selectEnableGlobalSearch).subscribe((enabled) => {
      this.isGlobalSearchEnabled = enabled;
    });
    this.document.addEventListener('keydown', this.handleKeyboardEvent.bind(this));
  }

  private handleKeyboardEvent(event: KeyboardEvent): void {
    const isMac = navigator.userAgent.toLowerCase().includes('mac');
    const key = event?.key.toLowerCase();
    const isCmdK = (isMac && event.metaKey && key === 'k') || (!isMac && event.ctrlKey && key === 'k');

    if (isCmdK && this.isGlobalSearchEnabled) {
      event.preventDefault();
      event.stopPropagation();
      this.openSearchDialog();
    }
  }

  private openSearchDialog(): void {
    // Prevent opening multiple dialogs
    if (this.isDialogOpen) {
      return;
    }

    this.isDialogOpen = true;
    // disableClose so the palette owns Escape: in AI chat mode the first Escape
    // must exit chat mode rather than close the dialog. Backdrop click is
    // re-wired explicitly below because disableClose suppresses that too.
    const dialogRef = this.dialog.open(SearchGlobalModalComponent, {
      width: '80vw',
      maxWidth: '1200px',
      disableClose: true,
      autoFocus: true
    });

    dialogRef.backdropClick().subscribe(() => dialogRef.close());

    this.searchDialogOpened.emit(true);

    dialogRef.afterClosed().subscribe(() => {
      this.isDialogOpen = false;
      this.searchDialogOpened.emit(false);
    });
  }

}
